<h4 class="font-weight-bold py-3 mb-4">Certificates</h4>
<!--<p>This page is an example of basic layout. For more options use <strong>Angular starter template generator</strong> in the docs.</p>-->
<!--<p><button class="btn btn-primary btn-lg">Button</button></p>-->
<div class="card mb-4">
  <h6 class="card-header">
    Certificates
  </h6>
  <div class="row no-gutters row-bordered">


<!--    <div class="col-sm-12 p-4">-->
<!--      <div class="row">-->
<!--        <div class="col-sm-4" *ngFor="let certificate of getCertificates() | filter:canViewCertificate()" class="certificate-add" (click)="viewCertificate(certificate)">-->
<!--          <div class="certificate-thumbnail" [ngStyle]="certificateThumbnail(certificate)"></div>-->
<!--          <span>{{certificate.identifier}}</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->


    <div class="col-sm-12 p-4">
      <table class="table table-striped">
        <thead>
        <tr>
          <th></th>
          <th>Reference</th>
          <th>Description</th>
          <th>Owner</th>
          <th>Issuer</th>
          <th>Expiry Date</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let certificate of getCertificates() | filter:canViewCertificate()" class="certificate-add" (click)="viewCertificate(certificate)">
          <th scope="row" class="certificate-thumbnail" [ngStyle]="certificateThumbnail(certificate)">
            <i *ngIf="!certificate.thumbnail" class="lnr lnr-license"></i>
          </th>
          <td>{{certificate.identifier}}</td>
          <td>{{certificate.description}}</td>
          <td>{{resolveUserFullname(certificate.owner)}}</td>
          <td>{{certificate.issuer}}</td>
          <td>{{certificate.expiryDate | date:'shortDate'}}</td>
          <td class="cert" [ngClass]="certificate.cssStatus()">
            {{certificate.readableStatus()}}
          </td>
        </tr>
        <tr *ngIf="(getCertificates() | filter:canViewCertificate()).length === 0">
          <td scope="row" colspan="7" style="text-align: center">
            You currently have no certificates.
          </td>
        </tr>
        <tr class="certificate-add" (click)="newCertificate()" *ngIf="canAddCertificate()">
          <td scope="row" colspan="7">
            <i class="lnr lnr-file-add certificate-add-icon"></i>
            <span>Add new certificate</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>

  <swal #successDialog title="Approved!" message="The certificate has been approved." [swalOptions]="{icon: 'success', customClass: {confirmButton:'btn btn-lg btn-success'}}"></swal>

</div>

